export const preventDefaultOnDropFiles = (e: any) => {
    if (e.dataTransfer.types) {
        for (let i = 0; i < e.dataTransfer.types.length; i++) {
            if (e.dataTransfer.types[i] === "Files") {
                e.preventDefault();
            }
        }
    }
}